import { EVENT } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { useBehavioralEventFilter } from '../../hooks/useBehavioralEventFilter';
import EditorConditionInputs from './EditorConditionInputs';
import EditorConditionRefinements from './EditorConditionRefinements';
import EditorRelatedConditionsGroupContainer from './EditorRelatedConditionsGroupContainer';
import EditorRelatedConditionsRefineButton from './EditorRelatedConditionsRefineButton';
import emptyFunction from 'react-utils/emptyFunction';
import ConditionError from '../common/ConditionError';
import EditorConditionAsset from './EditorConditionAsset';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import EditorConditionRefinementsContainer from './EditorConditionRefinementsContainer';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorBehavioralEventRelatedConditionsGroup = props => {
  var _condition$field;
  const {
    condition,
    conditionPath,
    dataSeleniumInfo
  } = props;
  const {
    onRefineFilter,
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(EVENT, conditionPath, condition);
  const {
    statusCondition,
    dateRefinementCondition,
    numberRefinementCondition,
    refinementConditionsEmptyValue
  } = useBehavioralEventFilter(condition);
  const {
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const hasInPlaceRefinementSelection = !!useOnePanel;

  //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
  const userHasNoAccess = (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.userHasNoAccess;
  const heading = /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(EditorConditionInputs, {
      condition: statusCondition,
      dataSeleniumInfo: dataSeleniumInfo,
      disabled: userHasNoAccess,
      filterFamily: EVENT,
      header: /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "200",
        as: "div",
        children: /*#__PURE__*/_jsx(EditorConditionAsset, {
          condition: condition,
          filterFamily: EVENT
        })
      }),
      onConditionOperatorChange: onFieldConditionOperatorChange,
      onConditionValueChange: emptyFunction
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    }), !hasInPlaceRefinementSelection && /*#__PURE__*/_jsx(EditorRelatedConditionsRefineButton, {
      dataSeleniumInfo: dataSeleniumInfo,
      disabled: userHasNoAccess,
      onClick: () => onRefineFilter(EVENT, conditionPath)
    }), hasInPlaceRefinementSelection && !userHasNoAccess && /*#__PURE__*/_jsx(EditorConditionRefinementsContainer, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: EVENT,
      onConditionChange: onFieldConditionValueChange,
      emptyRefinementConditions: refinementConditionsEmptyValue
    })]
  });
  return hasInPlaceRefinementSelection ? /*#__PURE__*/_jsx(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: EVENT,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath)
  }) : /*#__PURE__*/_jsx(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: EVENT,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath),
    children: /*#__PURE__*/_jsx(EditorConditionRefinements, {
      condition: condition,
      filterFamily: EVENT,
      onConditionChange: onFieldConditionValueChange,
      dateRefinement: dateRefinementCondition,
      numberRefinement: numberRefinementCondition
    })
  });
};
export default EditorBehavioralEventRelatedConditionsGroup;